import List from 'containers/Reviews/List';
import Edit from 'containers/Reviews/Edit';
import Create from 'containers/Reviews/Create';
import Show from 'containers/Reviews/Show';

export default { List, Edit, Create, Show };
